import React from "react";
import { withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from "prop-types";
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import RouterIcon from '@material-ui/icons/Router';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import * as helper from "../common/helper";
import SelectTable from './SelectTable';
import * as i18n from "../common/i18n";
import * as graphql from '../common/graphql';
import gql from 'graphql-tag';
import Message from "./Message";
import Grid from '@material-ui/core/Grid';
import "moment/locale/de";


moment.locale("de");

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: 'inline',
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: 200,
    },
});


class ExchangeDevice extends React.Component {
    constructor(props) {

        super(props);

        this.state = {
            device: null,
            exchangeDate: null,
            oldDeviceStatus: "STOCKED",
            statusDetails: i18n.get("devices.status.STOCKED"),
            message: null,
            activeStep: 0,
            steps: this.getSteps(),
            details: null,
            hideAfter: 3000,
            variant: "info",
            search: "",
        };
    }

    getSteps = () => {
        return [i18n.get("exchangeDevice.step.0"), i18n.get("exchangeDevice.step.1"), i18n.get("exchangeDevice.step.2"), i18n.get("exchangeDevice.step.3")];
    }

    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return this.selectDevice();
            case 1:
                return this.setExchangeDate();
            case 2:
                return this.setOldDeviceStatus();
            case 3:
                return this.showSummary();
            default:
                return 'Error';
        }
    }

    nextPossible = () => {
        switch (this.state.activeStep) {
            case 0:
                return this.state.device !== null
            case 1:
                return this.state.exchangeDate !== null
            case 2:
                return this.state.oldDeviceStatus !== null
            default:
                return true;
        }
    }

    onNext = async () => {
        const activeStep = this.state.activeStep + 1;
        this.setState({ activeStep: activeStep })
    }

    onPrevious = () => {
        const activeStep = this.state.activeStep - 1;
        this.setState({ activeStep: activeStep })
    }

    onAddDevice = (data) => {
        this.setState({
            device: data.uuid,
            deviceDetails: data
        });
    }

    onDeleteDevice = (data) => {
        this.setState({
            device: null,
            deviceDetails: {}
        });
    }

    onSetStatus = (event) => {
        switch (event.target.value) {
            case "STOCKED":
                this.setState({
                    oldDeviceStatus: "STOCKED",
                    statusDetails: i18n.get("devices.status.STOCKED")
                });
                break;
            case "MAINTENANCE":
                this.setState({
                    oldDeviceStatus: "MAINTENANCE",
                    statusDetails: i18n.get("devices.status.MAINTENANCE")
                });
                break;
            case "DEFECTIVE":
                this.setState({
                    oldDeviceStatus: "DEFECTIVE",
                    statusDetails: i18n.get("devices.status.DEFECTIVE")
                });
                break;
        }
    }

    onSave = () => {
        this.props.onSave(
            {
                device: this.state.device,
                deviceDetails: this.state.deviceDetails,
                exchangeDate: this.state.exchangeDate,
                oldDeviceStatus: this.state.oldDeviceStatus,
                leaseData: this.props.data,
            }
        );
        this.onClose();
    }

    onClose = () => {
        this.props.onCancel();
        this.reset();
    }

    reset = () => {
        this.setState(
            {
                message: null,
                activeStep: 0,
                device: null,
                deviceDetails: {},
                exchangeDate: null,
                oldDeviceStatus: "STOCKED",
                statusDetails: i18n.get("devices.status.STOCKED"),
                steps: this.getSteps(),
                details: null,
                hideAfter: 3000,
                variant: "info",
                search: "",
            }
        )
    }

    mapField(column) {
        return column;
    }

    selectDevice = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Kein Gerät ausgewählt. Wählen Sie ein Gerät aus der Liste aus"}
                        title1={"Gerät"}
                        title2={"Vorhandene Geräte"}
                        columns={[
                            {
                                title: "Geräte-ID",
                                hidden: false,
                                filtering: true,
                                field: "uuid"
                            },
                            {
                                title: "Geräte-IMEI",
                                hidden: false,
                                filtering: true,
                                field: "imei"
                            },

                        ]}
                        chipIcon={<RouterIcon />}
                        chipLabel={() => { return this.state.device }}
                        selected={this.state.device}
                        filtering={true}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    query["filters"].push({ column: { field: "status" }, operator: '=', value: "STOCKED" })
                                    const orderBy = helper.orderByString(query, this.mapField, "uuid", true);
                                    const where = helper.whereString(query["filters"], this.mapField, ["uuid"]);
                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                        query {
                                            devices(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Device {
                                                    id
                                                    uuid
                                                    imei
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });

                                    resolve({
                                        page: query.page,
                                        data: result.data.devices.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    uuid: element.uuid,
                                                    imei: element.imei
                                                };
                                            }),
                                        totalCount: result.data.devices.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        actions={[]}
                        onAdd={this.onAddDevice}
                        onDelete={this.onDeleteDevice}
                        onCancel={this.onClose}
                    />
                </Container>
            </React.Fragment>
        )
    }

    setExchangeDate = () => {
        if (this.state.exchangeDate === null) {
            this.setState({ exchangeDate: moment().format('YYYY-MM-DD') })
        }

        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"de"}>

                        <DatePicker
                            label={i18n.get("exchangeDevice.exchangeDate.label")}
                            inputVariant="outlined"
                            value={this.state.exchangeDate}
                            maxDate={moment()}
                            minDate={this.props.data.starts}
                            ampm={false}
                            cancelLabel={i18n.get("dateTimePicker.cancelLabel")}
                            okLabel={i18n.get("dateTimePicker.okLabel")}
                            showTodayButton={true}
                            format={"[ab dem] DD.MM.YYYY"}
                            todayLabel={i18n.get("dateTimePicker.todayLabel")}
                            onChange={(date) => { this.setState({ exchangeDate: date }) }}
                        />
                    </MuiPickersUtilsProvider>
                </Container>

            </React.Fragment>
        )
    }

    setOldDeviceStatus = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg" >
                    <FormControl variant="outlined" align="center" >
                        <Select
                            style={{ width: "50%", align: "center", alignItems: "center" }}
                            defaultValue={"STOCKED"}
                            onChange={this.onSetStatus}
                        >
                            <MenuItem value="STOCKED" align="center" > {i18n.get("devices.status.STOCKED")} </MenuItem>
                            <MenuItem value="DEFECTIVE" align="center" > {i18n.get("devices.status.DEFECTIVE")} </MenuItem>
                            <MenuItem value="MAINTENANCE" align="center" > {i18n.get("devices.status.MAINTENANCE")} </MenuItem>
                        </Select>
                    </FormControl>
                </Container>
            </React.Fragment>
        )
    }

    showSummary = () => {

        const data = [
            { label: i18n.get("exchangeDevice.summary.device"), value: `${this.state.deviceDetails.uuid} (${this.state.deviceDetails.imei})` },
            { label: i18n.get("exchangeDevice.summary.oldDeviceStatus"), value: `${this.state.statusDetails}` },
            { label: i18n.get("exchangeDevice.summary.exchangeDate"), value: `Ab dem ${moment(this.state.exchangeDate).format("DD.MM.YYYY")}` },
        ]

        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="md">

                    <Grid
                        container={true}
                        spacing={1}
                        justify={'center'}
                    >

                        {data && data.map(d =>
                            <React.Fragment>
                                <Grid item xs={12} lg={6}>
                                    <b>{d.label}</b>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    {d.value}
                                </Grid>
                            </React.Fragment>
                        )}

                    </Grid>

                </Container>
            </React.Fragment>

        )
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    render() {
        return (
            <Dialog
                maxWidth={"md"}
                fullWidth={true}
                open={this.props.open}
                data={this.props.data}
                keepMounted
                disableBackdropClick={true}
                onClose={this.onClose}
                fullScreen={false}
            >

                <DialogTitle>
                    <React.Fragment>
                        {i18n.get("exchangeDevice.title")}
                        <Stepper activeStep={this.state.activeStep}>
                            {this.state.steps.map(label => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </React.Fragment>
                </DialogTitle>
                <DialogContent>
                    {this.getStepContent(this.state.activeStep)}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose} color="primary">
                        {i18n.get("exchangeDevice.cancel")}
                    </Button>
                    {this.state.activeStep > 0 &&
                        <Button onClick={this.onPrevious} color="primary">
                            {i18n.get("exchangeDevice.previous")}
                        </Button>
                    }
                    {this.state.activeStep >= 0 && this.state.activeStep < (this.state.steps.length - 1) &&
                        <Button onClick={this.onNext} color="primary" disabled={!this.nextPossible()}>
                            {i18n.get("exchangeDevice.next")}
                        </Button>
                    }
                    {this.state.activeStep === (this.state.steps.length - 1) &&
                        <Button onClick={this.onSave} color="primary">
                            {i18n.get("exchangeDevice.save")}
                        </Button>
                    }
                </DialogActions>

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </Dialog>
        );
    }
}

ExchangeDevice.propTypes = {
    classes:
        PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ExchangeDevice)
